<section class="container-fluid px-5 py-4">
    
    <header class="row pt-3">
        <div class="col-12 d-flex justify-content-between">
            <div>
                <h2 class="text-left text-white">Ingreso de pago: {{title}}</h2>
                <h6 class="text-secondary"></h6>
            </div>
            
            <div class="d-flex justify-content-center align-items-center">
      
                <button
                  class="badge rounded-pill btn btn-outline-light"
                  (click)="goBack()"
                >
                  <i
                    class="fa-solid fa-right-from-bracket m-2 fs-6"
                    aria-hidden="true"
                  ></i>
                  <span class="m-2 fs-6">Volver</span>
                </button>
          
          
              </div>
            <!-- <div>
                <button class="me-1 btn btn-outline-light" routerLink="./../list" ><i class="fa-solid fa-right-from-bracket" aria-hidden="true"></i> Volver al listado de proyectos</button>
                <button *ngIf="step > 1"  class="mx-2 btn btn-outline-light "(click)="step=step-1"><i class="fa fa-arrow-left" aria-hidden="true"></i> Volver a la etapa anterior</button>
                <button *ngIf="step < 4"  class="ms-1 btn btn-outline-light" (click)="step=step+1" > <i class="fa fa-arrow-right" aria-hidden="true"></i> Siguiente etapa</button>
            </div>            -->
        </div>
    </header>
</section>

<div class="mx-5">
    <section class="container-fluid shadow pt-3 pb-2 text-white backgroundTable mt-3 " style="min-height:750px !important;">
        <div class="my-1 container-fluid d-flex justify-content-between align-items-center">
            <div>
                <h5 class="ms-3">Crear nuevo pago.</h5>
            </div>
        </div>


<div class="componente-importantes text-start px-5 mt-3" style="min-height:700px;" *ngIf="this.datos != null">
    <div class=" py-4">
        <div class="container-fluid text-white d-flex justify-content-between">
          <div>
            <span>Pago: </span>
            <span>{{ this.datos.title }}</span>
          </div>
          <div>
            <span>Monto: </span>
            <span>{{ this.datos.amount }}</span>
          </div>
          <div>
            <span>Porcentaje: </span>
            <span>{{ this.datos.amount_percent }}%</span>
          </div>
          <div>
            <span>Fecha: </span>
            <span>{{ this.datos.date_payment }}</span>
          </div>
          <div>
            <span>Estados:  </span>
            <span *ngIf="this.datos.status === 'REPROGRAMADO'"
                class="badge rounded-pill text-bg-warning " style="font-size: 12px;">{{this.datos.status}}</span>
                <span *ngIf="this.datos.status === 'PAGADO'"
                class="badge rounded-pill text-bg-success  " style="font-size: 12px;">{{this.datos.status}}</span>
                <span *ngIf="this.datos.status === 'ANULADO'"
                class="badge rounded-pill text-bg-danger " style="font-size: 12px;">{{this.datos.status}}</span>
                <span *ngIf="this.datos.status === 'PENDIENTE'"
                class="badge rounded-pill text-bg-info" style="font-size: 12px;">{{this.datos.status}}</span>
                <span *ngIf="this.datos.status != 'PENDIENTE' && this.datos.status != 'ANULADO' && this.datos.status != 'PAGADO' && this.datos.status != 'REPROGRAMADO'"
                class="badge rounded-pill text-bg-default p-2 " style="font-size: 12px;">SIN REGISTRO</span>
        </div>
    
    
        </div>
      </div>
    <form action="" method="post" (submit)="formSubmit()" [formGroup]="createPayForm">


        <div class="form-group mt-1">
            <label for="formControlInput" class="form-label">Fecha Real:</label>
            <input type="date" class="form-control custom-outline-input date" id="date_pay"
                formControlName="date_pay">
        </div>
        <div class="form-group mt-1">
            <label for="formControlInput" class="form-label">Observaciones:</label>
            <textarea
            class="form-control custom-outline-input date"
            placeholder="Dejar detalles aqui..."
            formControlName="description"
            id="description"
            style="height: 100px !important"
            ></textarea>
        </div>

        <!-- <label for="formControlInput" class="form-label mt-3">{{this.datos.name}}</label> -->
        <label for="formControlInput" class="form-label mt-3">INGRESAR INFORMACION</label>
        <a (click)="nuevoCampo()"  class="mx-2 btn btn-outline-light mt-3 float-end"> <i class="fa-solid fa-plus" aria-hidden="true"></i></a>

        <form [formGroup]="paymentsform" class="mt-2">

        <div class="mt-2" formArrayName="items" *ngFor="let item of paymentsform.get('items')['controls']; let i = index;">
            <div class="row" [formGroupName]="i">
            <div class="col-3 ">
                <div class="form-group mt-1">
                <label for="formControlInput" class="form-label">Her:</label>
                <input type="text" placeholder="HES" class="form-control custom-outline-input" formControlName="hes">
                </div>
            </div>
            <div class="col-4">
                <div class="form-group mt-1">
                    <label for="formControlInput" class="form-label">Factura:</label>
                <input type="text" placeholder="FACTURA" class="form-control custom-outline-input" formControlName="facture">
                </div>
            </div>
          
            <div class="col-4">
            <div class="form-group mt-1">
                <label for="formControlInput" class="form-label">Fecha factura:</label>
                <input type="date" placeholder="FECHA FACTURA" class="form-control custom-outline-input date" id="facture_date"
                    formControlName="facture_date">
            </div>
            </div>
            <div class="col-1">
                <button *ngIf="i != 0" (click)="eliminarCampo(i)"  class="mx-2 btn btn-outline-light mt-1 float-end"> <i class="fa-solid fa-trash-can" aria-hidden="true"></i></button>
            </div>
            </div>


        </div>


        </form>


    <br>
        <div class="form-group d-flex justify-content-sm-end mt-4">
            <div>
                <button class="btn btn-outline-light me-3" style="font-size: 15px;"> <i _ngcontent-xfk-c127=""
                        class="fa-solid fa-floppy-disk m-1"></i> Guardar</button>
            </div>




        </div>


    </form>


</div>



</section>
</div>



<router-outlet></router-outlet>